import { RootState } from 'app/store';

export const selectSiteSettings =
  (locale: string): any =>
  (state: RootState) =>
    state.core?.settings?.[locale]?.PageData?.siteSettings;

export const selectMainMenu =
  (locale: string): any =>
  (state: RootState) =>
    state.core?.settings?.[locale]?.MainMenu;

export const selectPageSettings = (locale: string) => (state: RootState) =>
  state?.core?.settings?.[locale]?.PageData;

export const selectLocalePath = (state: RootState) => state?.core?.languagePath;

export const selectMasterLanguage = (state: RootState) =>
  state?.core?.masterLanguage || 'en';

export const selectCurrentMarket = (state: RootState) =>
  state?.core?.currentMarket;

export const selectUser = (state: RootState) => state?.core?.user;

export const selectDataLoading = (state: RootState) => state?.core?.dataLoading;
